export const quickAccessOptions = [
  {
    option: "No MSG",
  },
  {
    option: "No Onions",
  },
  {
    option: "No Peppers",
  },
  {
    option: "No Mushrooms",
  },
  {
    option: "No Peas",
  },
  {
    option: "No Carrot",
  },
  {
    option: "No Celery",
  },
  {
    option: "No Egg",
  },
  {
    option: "No Corn",
  },
  {
    option: "No Bean Sprout",
  },
  {
    option: "Less Salt",
  },
  {
    option: "Less Oil",
  },
  {
    option: "Gluten Free",
    special: true,
  },
  {
    option: "Extra Soft",
    special: true,
  },
  {
    option: "Extra Crispy",
    special: true,
  },
  {
    option: "Mild",
    special: true,
  },
  {
    option: "Sauce on Side",
    special: true,
  },
  {
    option: "Extra Sauce",
    special: true,
  },
];

export const quickAccessPopSelection = [
  {
    option: "Coke",
    large: true,
  },
  {
    option: "Diet Coke",
  },
  {
    option: "Coke Zero",
    large: true,
  },
  {
    option: "Pepsi",
    large: true,
  },
  {
    option: "Fanta",
  },
  {
    option: "Sprite",
  },
  {
    option: "Ginger Ale",
    large: true,
  },
  {
    option: "Fuze",
  },
  {
    option: "Root Beer",
  },
];
